import { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import "animate.css";
import TrackVisibility from "react-on-screen";
import n5 from "../assets/projects/n5.jpeg";
import n17 from "../assets/projects/n17.jpeg";
import n13 from "../assets/projects/n13.png";
// Make sure you have this image or change the name!
import n9 from "../assets/projects/n9.jpeg"; 

import {
  FaReact,
  FaHtml5,
  FaCss3Alt,
  FaNodeJs,
  FaGithub,
  FaApple,
  FaBootstrap,
  FaJira,
} from "react-icons/fa";
import { IoLogoJavascript, IoLogoFirebase } from "react-icons/io5";
import { DiMongodb } from "react-icons/di";
import { SiNestjs, SiRedux, SiExpress } from "react-icons/si";
import { BsAndroid2 } from "react-icons/bs";
import { RiExternalLinkFill } from "react-icons/ri";

export const Featured = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = ["Web Developer", "Mobile App Developer", "Web Designer"];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex((prevIndex) => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex((prevIndex) => prevIndex + 1);
    }
  };

  return (
    <section className="featured" id="featured">
      <Container>
        <div className="row">
          <h1 className="featured-head">Featured Projects</h1>
        </div>

        {/* ==============================================
            PROJECT 1: SCHOOLOGY 
            Layout: Text Left | Image Right
           ============================================== */}
        <div className="row">
          <div className="col-md-6 col-sm-12 divDetail">
            <div className="innerDivDetail">
              <h1 className="iDo">Schology</h1>
              <a
                href="https://play.google.com/store/apps/details?id=com.schoology.app&hl=en/"
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none", color: "white" }}
              >
                <h5>
                  Education Through Innovation{" "}
                  <RiExternalLinkFill className="externalLink" />
                </h5>
              </a>
              <TrackVisibility>
                {({ isVisible }) => (
                  <a
                    className={isVisible ? "detailIconsVisible" : "detailIcons"}
                    style={{
                      textDecoration: "none",
                      marginTop: "5px",
                      marginBottom: "5px",
                    }}
                  >
                    <FaGithub
                      style={{
                        fontSize: "12px",
                        marginRight: "5px",
                      }}
                    />{" "}
                    PRIVATE
                  </a>
                )}
              </TrackVisibility>
              <p className="desc" style={{ fontSize: "15px" }}>
                Schology is a unified digital platform, designed to bridge the gap
                between schools, students, and parents. It streamlines
                educational resource management, enhances parent collaboration,
                and centralizes communication among stakeholders. The platform
                has successfully onboarded over 100 schools, significantly
                improving engagement and academic performance tracking.
              </p>
              <div className="detailIconDiv">
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <FaReact style={{ marginRight: "5px" }} /> REACTNATIVE
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <IoLogoJavascript style={{ marginRight: "5px" }} /> JAVASCRIPT
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <FaHtml5 style={{ marginRight: "5px" }} /> HTML5
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <FaCss3Alt style={{ marginRight: "5px" }} /> CSS3
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <FaNodeJs style={{ marginRight: "5px" }} /> NODEJS
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <DiMongodb style={{ marginRight: "5px" }} /> MONGODB
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <FaGithub style={{ marginRight: "5px" }} /> GITHUB
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <SiNestjs style={{ marginRight: "5px" }} /> NESTJS
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <BsAndroid2 style={{ marginRight: "5px" }} /> ANDROID
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <FaApple style={{ marginRight: "5px" }} /> IOS
                    </p>
                  )}
                </TrackVisibility>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-12 divImage">
            <TrackVisibility>
              {({ isVisible }) => (
                <div>
                  <img
                    src={n5}
                    className="img1"
                    alt="Schology App"
                    loading="lazy"
                    decoding="async"
                    width="500"
                    height="300"
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                </div>
              )}
            </TrackVisibility>
          </div>
        </div>

        {/* ==============================================
            PROJECT 2: UNIFY TAXI APP 
            Layout: Image Left | Text Right
           ============================================== */}
        <div className="row project2">
          {/* IMAGE (Left on Desktop) */}
          <div className="col-md-6 col-sm-12 order-md-1 order-2 divImage">
            <TrackVisibility>
              {({ isVisible }) => (
                <div>
                  <img
                    src={n17}
                    className="img2"
                    alt="Unify Taxi App"
                    loading="lazy"
                    decoding="async"
                    width="500"
                    height="300"
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                </div>
              )}
            </TrackVisibility>
          </div>

          {/* TEXT (Right on Desktop) */}
          <div className="col-md-6 col-sm-12 order-md-2 order-1 divDetail">
            <div className="innerDivDetail">
              <h1 className="iDo">Unify Taxi App</h1>
              <a
                href="https://play.google.com/store/apps/details?id=com.gettaxi.android&hl=en_GB"
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none", color: "white" }}
              >
                <h5>
                  Instant & secure London taxi booking.
                  <RiExternalLinkFill
                    className="externalLink"
                    style={{ marginLeft: "5px" }}
                  />
                </h5>
              </a>
              <TrackVisibility>
                {({ isVisible }) => (
                  <div
                    className={isVisible ? "detailIconsVisible" : "detailIcons"}
                    style={{
                      marginTop: "5px",
                      marginBottom: "5px",
                    }}
                  >
                    <FaGithub
                      style={{
                        fontSize: "12px",
                        marginRight: "5px",
                      }}
                    />{" "}
                    PRIVATE
                  </div>
                )}
              </TrackVisibility>
              <p
                className="desc"
                style={{ fontSize: "15px", textAlign: "left" }}
              >
                The Unify London Taxi App revolutionizes the way you hire taxis
                in London, providing a seamless and efficient booking experience.
                With its user-friendly interface, you can easily book black taxis
                for both instant and advance trips, making it perfect for
                spontaneous outings or pre-planned journeys.
              </p>
              <div className="detailIconDiv">
                <p className="detailIcons">
                  <FaReact style={{ marginRight: "5px" }} /> REACT
                </p>
                <p className="detailIcons">
                  <SiRedux style={{ marginRight: "5px" }} /> REDUX
                </p>
                <p className="detailIcons">
                  <FaBootstrap style={{ marginRight: "5px" }} /> BOOTSTRAP
                </p>
                <p className="detailIcons">
                  <FaJira style={{ marginRight: "5px" }} /> JIRA
                </p>
                <p className="detailIcons">
                  <FaNodeJs style={{ marginRight: "5px" }} /> NODEJS
                </p>
                <p className="detailIcons">
                  <SiExpress style={{ marginRight: "5px" }} /> EXPRESS
                </p>
                <p className="detailIcons">
                  <IoLogoFirebase style={{ marginRight: "5px" }} /> FIREBASE
                </p>
                <p className="detailIcons">
                  <IoLogoJavascript style={{ marginRight: "5px" }} /> JAVASCRIPT
                </p>
                <p className="detailIcons">
                  <FaHtml5 style={{ marginRight: "5px" }} /> HTML5
                </p>
                <p className="detailIcons">
                  <FaCss3Alt style={{ marginRight: "5px" }} /> CSS3
                </p>
                <p className="detailIcons">
                  <FaNodeJs style={{ marginRight: "5px" }} /> NODEJS
                </p>
                <p className="detailIcons">
                  <DiMongodb style={{ marginRight: "5px" }} /> MONGODB
                </p>
                <p className="detailIcons">
                  <FaGithub style={{ marginRight: "5px" }} /> GITHUB
                </p>
                <p className="detailIcons">
                  <SiNestjs style={{ marginRight: "5px" }} /> NESTJS
                </p>
                <p className="detailIcons">
                  <BsAndroid2 style={{ marginRight: "5px" }} /> ANDROID
                </p>
                <p className="detailIcons">
                  <FaApple style={{ marginRight: "5px" }} /> IOS
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ==============================================
            PROJECT 3: BETTER THE NEXT DAY (NEW)
            Layout: Text Left | Image Right
           ============================================== */}
        <div className="row">
          <div className="col-md-6 col-sm-12 divDetail">
            <div className="innerDivDetail">
              <h1 className="iDo">Better The Next Day</h1>
              <a
                href="#"
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none", color: "white" }}
              >
                <h5>
                  Fitness app with workouts and community.{" "}
                  <RiExternalLinkFill className="externalLink" />
                </h5>
              </a>
              <TrackVisibility>
                {({ isVisible }) => (
                  <div
                    className={isVisible ? "detailIconsVisible" : "detailIcons"}
                    style={{
                      marginTop: "5px",
                      marginBottom: "5px",
                    }}
                  >
                    <FaGithub
                      style={{
                        fontSize: "12px",
                        marginRight: "5px",
                      }}
                    />{" "}
                    PRIVATE
                  </div>
                )}
              </TrackVisibility>
              <p className="desc" style={{ fontSize: "15px" }}>
                Developed a fitness app called Better The Next Day (BTND) for iOS
                and Android, featuring a user-friendly interface, subscription
                plans, a comprehensive workout library, and a community-driven
                Running Club. The app also includes a web-based admin panel for
                easy management. The client praised Intelivita for exceeding
                expectations and significantly boosting user engagement.
              </p>
              <div className="detailIconDiv">
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <FaReact style={{ marginRight: "5px" }} /> REACTNATIVE
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <IoLogoJavascript style={{ marginRight: "5px" }} /> JAVASCRIPT
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <FaHtml5 style={{ marginRight: "5px" }} /> HTML5
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <FaCss3Alt style={{ marginRight: "5px" }} /> CSS3
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <FaNodeJs style={{ marginRight: "5px" }} /> NODEJS
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <DiMongodb style={{ marginRight: "5px" }} /> MONGODB
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <FaGithub style={{ marginRight: "5px" }} /> GITHUB
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <SiNestjs style={{ marginRight: "5px" }} /> NESTJS
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <BsAndroid2 style={{ marginRight: "5px" }} /> ANDROID
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <FaApple style={{ marginRight: "5px" }} /> IOS
                    </p>
                  )}
                </TrackVisibility>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-12 divImage">
            <TrackVisibility>
              {({ isVisible }) => (
                <div>
                  <img
                    src={n9} // Ensure you have this image or change to {n5}
                    className="img1"
                    alt="Better The Next Day"
                    loading="lazy"
                    decoding="async"
                    width="500"
                    height="300"
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                </div>
              )}
            </TrackVisibility>
          </div>
        </div>

        {/* ==============================================
            PROJECT 4: MOVIX (Flipped for Zig-Zag)
            Layout: Image Left | Text Right
           ============================================== */}
        <div className="row project2">
          {/* IMAGE (Left Desktop) */}
          <div className="col-md-6 col-sm-12 order-md-1 order-2 divImage">
            <TrackVisibility>
              {({ isVisible }) => (
                <div>
                  <img
                    src={n13}
                    className="img2"
                    alt="MoviX"
                    loading="lazy"
                    decoding="async"
                    width="500"
                    height="300"
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                </div>
              )}
            </TrackVisibility>
          </div>
          
          {/* TEXT (Right Desktop) */}
          <div className="col-md-6 col-sm-12 order-md-2 order-1 divDetail">
            <div className="innerDivDetail">
              <h1 className="iDo">MoviX</h1>
              <a
                href="https://movie-raiting-app.vercel.app"
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none", color: "white" }}
              >
                <h5>
                  Your Ultimate Movie Experience{" "}
                  <RiExternalLinkFill className="externalLink" />
                </h5>
              </a>
              <TrackVisibility>
                {({ isVisible }) => (
                  <a
                    className={isVisible ? "detailIconsVisible" : "detailIcons"}
                    style={{
                      textDecoration: "none",
                      marginTop: "5px",
                      marginBottom: "5px",
                    }}
                    // href="Private"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaGithub
                      style={{
                        fontSize: "12px",
                        marginRight: "5px",
                      }}
                    />{" "}
                    Private
                  </a>
                )}
              </TrackVisibility>
              <p className="desc" style={{ fontSize: "15px", textAlign: "left" }}>
                Discover a universe of cinematic wonders with our
                trailer-focused movie app. Dive into a collection where every
                click unveils captivating previews, offering a glimpse into the
                heart of each film.
              </p>
              <div className="detailIconDiv">
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <FaReact style={{ marginRight: "5px" }} /> REACT
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <IoLogoJavascript style={{ marginRight: "5px" }} /> JAVASCRIPT
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <FaHtml5 style={{ marginRight: "5px" }} /> HTML5
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <FaCss3Alt style={{ marginRight: "5px" }} /> CSS3
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <FaNodeJs style={{ marginRight: "5px" }} /> NODEJS
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <DiMongodb style={{ marginRight: "5px" }} /> MONGODB
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <FaGithub style={{ marginRight: "5px" }} /> GITHUB
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <SiNestjs style={{ marginRight: "5px" }} /> NESTJS
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <BsAndroid2 style={{ marginRight: "5px" }} /> ANDROID
                    </p>
                  )}
                </TrackVisibility>
                <TrackVisibility>
                  {({ isVisible }) => (
                    <p className={isVisible ? "detailIconsVisible" : "detailIcons"}>
                      <FaApple style={{ marginRight: "5px" }} /> IOS
                    </p>
                  )}
                </TrackVisibility>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};